import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import type { SitesResponse } from '@api/sites'
import sites from '@api/sites'

const baseKey = 'sites'

export const useSite = ({ siteAbb }: { siteAbb?: string }) =>
  useQuery({
    queryKey: [baseKey, siteAbb],
    queryFn: () => sites.getSite({ siteAbb }),
    enabled: !!siteAbb,
  })

const getSitesBaseKey = 'getAllSitesData'
export const useSites = (): UseQueryResult<SitesResponse> =>
  useQuery({
    queryKey: [getSitesBaseKey],
    queryFn: () => sites.getSites(),
  })
